import { AxiosPromise } from 'axios'

import { AccessToken } from '@okta/okta-auth-js'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { useRouteContext } from '@tanstack/react-router'

import { api } from '../utils/api'
import { getAuthorizationService } from '../utils/auth'

export type FeatureFlag = {
  isEnabled: boolean
  name: Feature
}

export enum Feature {
  ProductAdministrationsRead = 'productenAdministratieLezen',
  SetPrimaryCharacteristic = 'productenBelangrijksteKenmerkBewerken',
  MutateCoolingRegimeProduct = 'productenKoelregimesBewerken',
  MutateCoolingRegimeGenus = 'geslachtenKoelregimesBewerken',
  MutateCoolingRegimeTemperature = 'koelregimesTemperatuurBewerken',
  MutateCoolingRegimePriority = 'koelregimesPrioriteitBewerken',
}

export const getFeatures = (): AxiosPromise<FeatureFlag[]> =>
  api.get('/api/v1/Features')

export const useFeatureFlag = (featureFlag: Feature): boolean => {
  const { enabledFeatures } = useRouteContext({ strict: false })
  return enabledFeatures?.includes(featureFlag) ?? false;
}

export const useFeatureFlags = (token?: AccessToken): UseQueryResult<any> =>
  useQuery({
    queryKey: ['Features'],
    queryFn: getFeatures,
    staleTime: 0,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    enabled: Boolean(token && getAuthorizationService().hasRequiredScopeSync(token)),
    select: ({ data }) =>
      import.meta.env.DEV
        ? Object.values(Feature)
        : data.filter(({ isEnabled }) => isEnabled).map(({ name }) => name),
  })
